import Glossary from "@/views/CMS/Glossary/Glossary.vue";
const routes = [
    {
        path: "/cms/glossary/list",
        name: "Glossary",
        component: Glossary,
    },
];
export default routes;
